// import {
//   FaTruck,
//   FaUser,
//   FaShoppingCart,
//   FaSearch,
// } from "react-icons/fa";

// export default function TopBar() {
//   return (
//     <div className="bg-white shadow-sm px-6 py-4">
//       <div className="max-w-7xl mx-auto flex flex-wrap gap-4 items-center justify-between">

//         <div className="flex items-center gap-3">
//           <div className="w-10 h-10">
//   <img
//     src="/logo.png"
//     alt="Logo"
//     className="w-full h-full object-contain"
//   />
// </div>

//           <h1 className="text-4xl font-bold text-blue-950">
//             GM <span className="font-normal">Store</span>
//           </h1>
//         </div>

//         <div className="flex flex-1 max-w-3xl">
//           <select className="border p-3 rounded-l-lg">
//             <option>All Categories</option>
//           </select>

//           <input
//             type="text"
//             placeholder="Search products..."
//             className="border flex-1 p-3"
//           />

//           <button className="bg-blue-950 px-5 text-white rounded-r-lg">
//             <FaSearch />
//           </button>
//         </div>

//         <div className="flex gap-8">

//           <div className="flex gap-2">
//             <FaTruck size={24} />
//             <div>
//               <p className="font-semibold">
//                 Easy Delivery
//               </p>
//               <small>At Your Home</small>
//             </div>
//           </div>

//           <div className="flex gap-2">
//             <FaUser size={24} />
           
//           </div>

//           <div className="flex gap-2">
//             <FaShoppingCart size={24} />
//             <div>
//               <p className="font-semibold">
//                 My Cart
//               </p>
//               <small>$0.00</small>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }








import {
  FaTruck,
  FaUser,
  FaShoppingCart,
  FaSearch,
} from "react-icons/fa";

export default function TopBar() {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-4">

        {/* Top Section */}
        <div className="flex flex-col lg:flex-row items-center gap-4 justify-between">

          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="Logo"
              className="w-10 h-10 object-contain"
            />

            <h1 className="text-2xl sm:text-3xl font-bold text-blue-950">
              GM <span className="font-normal">Store</span>
            </h1>
          </div>

          {/* Search Bar */}
          <div className="w-full lg:flex-1 lg:max-w-3xl">
            <div className="flex w-full">
              <select className="hidden sm:block border border-r-0 px-3 rounded-l-lg bg-white">
                <option>All Categories</option>
              </select>

              <input
                type="text"
                placeholder="Search products..."
                className="flex-1 border p-3 focus:outline-none focus:ring-2 focus:ring-blue-900"
              />

              <button className="bg-blue-950 px-5 text-white rounded-r-lg hover:bg-blue-800 transition">
                <FaSearch />
              </button>
            </div>
          </div>

          {/* Right Side */}
        <div className="flex items-center justify-center gap-4 sm:gap-6">

  {/* Delivery */}
  <div className="flex items-center gap-2">
    <FaTruck
      size={20}
      className="text-blue-950 flex-shrink-0"
    />

    <div className="hidden xs:block">
      <p className="font-semibold text-xs sm:text-sm">
        Easy Delivery
      </p>
      <small className="text-gray-500 text-[10px] sm:text-xs">
        At Your Home
      </small>
    </div>
  </div>

  {/* User */}
  <button className="p-2 rounded-full hover:bg-gray-100 transition">
    <FaUser
      size={20}
      className="text-blue-950"
    />
  </button>

  {/* Cart */}
  <button className="flex items-center gap-2 hover:bg-gray-100 px-2 py-1 rounded-lg transition">
    <div className="relative">
      <FaShoppingCart
        size={20}
        className="text-blue-950"
      />

      <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">
        0
      </span>
    </div>

    <div>
      <p className="font-semibold text-xs sm:text-sm">
        My Cart
      </p>
      <small className="text-gray-500 text-[10px] sm:text-xs">
        $0.00
      </small>
    </div>
  </button>

</div>
        </div>
      </div>
    </header>
  );
}